<div class="contact-row">
    <div class="flex-container contact-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="100px">
            <div>
                <app-contact-row-icons [item]="item"></app-contact-row-icons>
            </div>
            <div>{{ getDate() }}</div>
            <div style="width:100px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ getUser() }}</div>
        </div>
        <div fxFlex="grow">
            <app-contact-row-content [item]="item"></app-contact-row-content>
        </div>
    </div>
</div>